/**
 * RT Product Reviews - assets/rt-product-reviews.js  v3.2
 * Form is built by JS and injected into #rt-reviews-form-portal
 * which sits OUTSIDE the section div - completely escaping Xtra theme color cascade.
 */
(function () {
  'use strict';

  const starLabels = ['', 'Terrible', 'Poor', 'Okay', 'Good', 'Excellent - love it!'];
  let selectedRating = 0;

  function init() {
    buildForm();
    initScrollAnimations();
  }

  /* ── Build form HTML into portal ─────────────────────────────────────── */
  function buildForm() {
    const portal = document.getElementById('rt-reviews-form-portal');
    const meta   = document.getElementById('rt-form-data');
    if (!portal || !meta) return;

    const webhook   = meta.dataset.webhook || '';
    const productId = meta.dataset.productId || '';
    const handle    = meta.dataset.productHandle || '';
    const title     = meta.dataset.productTitle || '';

    portal.innerHTML = `
      <div id="rt-pr-form-wrap" style="
        overflow:hidden;max-height:0;opacity:0;
        transition:max-height .5s cubic-bezier(.4,0,.2,1),opacity .4s;
        background:#fff;color:#111;
        scroll-margin-top:100px;
      ">
        <div style="
          background:#fafafa;color:#111;
          border-top:2px solid #E63946;
          padding:28px 24px 32px 24px;
        ">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:24px;gap:12px">
            <h3 style="font-size:13px;font-weight:700;color:#111;margin:0;background:transparent">
              Your Review <em id="rt-form-title-em" style="font-style:normal;color:#aaa;font-weight:400;background:transparent"></em>
            </h3>
            <button id="rt-close-btn" aria-label="Close review form" style="
              all:unset;cursor:pointer;width:28px;height:28px;
              border:1px solid #e0e0e0;display:flex;align-items:center;
              justify-content:center;font-size:18px;color:#aaa;flex-shrink:0;
              transition:all .2s;box-sizing:border-box;
            ">×</button>
          </div>

          <div style="margin-bottom:16px">
            <label style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">
              RATING <span style="color:#E63946">*</span>
            </label>
            <div id="rt-star-pick" style="display:flex;gap:4px"></div>
            <div id="rt-star-hint" style="font-size:11px;color:#E63946;min-height:16px;margin-top:4px;opacity:0;transition:opacity .2s;background:transparent"></div>
            <div id="rt-err-rating" style="font-size:11px;color:#E63946;background:transparent"></div>
          </div>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:16px">
            <div>
              <label for="rt-name" style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">NAME <span style="color:#E63946">*</span></label>
              <input id="rt-name" name="name" type="text" placeholder="Rahul M." maxlength="100" autocomplete="given-name"
                style="width:100%;font-family:inherit;font-size:13px;color:#111;background:#fff;border:1px solid #e5e5e5;padding:10px 14px;outline:none;box-sizing:border-box;border-radius:0">
              <div id="rt-err-name" style="font-size:11px;color:#E63946;background:transparent"></div>
            </div>
            <div>
              <label for="rt-email" style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">EMAIL <span style="color:#E63946">*</span></label>
              <input id="rt-email" name="email" type="email" placeholder="you@email.com" autocomplete="email"
                style="width:100%;font-family:inherit;font-size:13px;color:#111;background:#fff;border:1px solid #e5e5e5;padding:10px 14px;outline:none;box-sizing:border-box;border-radius:0">
              <div id="rt-err-email" style="font-size:11px;color:#E63946;background:transparent"></div>
            </div>
          </div>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:16px">
            <div>
              <label for="rt-bike" style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">YOUR BIKE <span style="color:#ccc;font-weight:400;text-transform:none;letter-spacing:0">(optional)</span></label>
              <input id="rt-bike" name="bike_model" type="text" placeholder="e.g. RE Himalayan 450" maxlength="100"
                style="width:100%;font-family:inherit;font-size:13px;color:#111;background:#fff;border:1px solid #e5e5e5;padding:10px 14px;outline:none;box-sizing:border-box;border-radius:0">
            </div>
            <div>
              <label for="rt-city" style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">CITY <span style="color:#ccc;font-weight:400;text-transform:none;letter-spacing:0">(optional)</span></label>
              <input id="rt-city" name="city" type="text" placeholder="e.g. Bengaluru" maxlength="60"
                style="width:100%;font-family:inherit;font-size:13px;color:#111;background:#fff;border:1px solid #e5e5e5;padding:10px 14px;outline:none;box-sizing:border-box;border-radius:0">
            </div>
          </div>

          <div style="margin-bottom:16px">
            <label for="rt-body" style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">YOUR REVIEW <span style="color:#E63946">*</span></label>
            <textarea id="rt-body" name="body" rows="4" placeholder="Fitment, quality, delivery - tell other riders what to expect."
              style="width:100%;font-family:inherit;font-size:13px;color:#111;background:#fff;border:1px solid #e5e5e5;padding:10px 14px;outline:none;resize:vertical;min-height:96px;box-sizing:border-box;border-radius:0"></textarea>
            <div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px">
              <div id="rt-err-body" style="font-size:11px;color:#E63946;background:transparent"></div>
              <span style="font-size:10px;color:#ddd;background:transparent"><span id="rt-body-count">0</span>/1000</span>
            </div>
          </div>

          <div style="margin-bottom:16px">
            <label style="display:block;font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#666;margin-bottom:6px;background:transparent">
              PHOTOS <span style="color:#ccc;font-weight:400;text-transform:none;letter-spacing:0">(optional · max 3 · jpg/png/webp · 5MB each)</span>
            </label>
            <div id="rt-photo-drop" style="
              border:1.5px dashed #e0e0e0;padding:16px;text-align:center;
              cursor:pointer;transition:border-color .2s;background:#fafafa;
              display:flex;flex-direction:column;align-items:center;gap:8px;
            ">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="color:#ccc" aria-hidden="true">
                <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 20M14 8h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span style="font-size:12px;color:#aaa;background:transparent">Tap to add photos of your install / product</span>
              <input id="rt-photo-input" type="file" accept="image/jpeg,image/png,image/webp" multiple style="display:none" aria-label="Upload review photos">
            </div>
            <div id="rt-photo-preview" style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px"></div>
            <div id="rt-photo-err" style="font-size:11px;color:#E63946;margin-top:4px;background:transparent"></div>
          </div>

          <input type="hidden" id="rt-rating" value="">
          <input type="hidden" id="rt-product-id" value="${productId}">
          <input type="hidden" id="rt-product-handle" value="${handle}">
          <input type="hidden" id="rt-product-title" value="${title}">
          <input type="hidden" id="rt-webhook" value="${webhook}">

          <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-top:20px">
            <p style="font-size:11px;color:#ccc;margin:0;background:transparent">Moderated · posted within 24 hrs</p>
            <button id="rt-submit" style="
              display:inline-flex;align-items:center;gap:8px;
              background:#E63946;color:#fff;border:none;cursor:pointer;
              font-family:inherit;font-size:10px;font-weight:700;
              letter-spacing:2px;text-transform:uppercase;padding:13px 32px;
              transition:background .2s;
            ">
              <span>Post Review</span>
              <svg id="rt-spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" style="display:none;animation:rt-spin .7s linear infinite" aria-hidden="true">
                <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" stroke-dasharray="20 18" stroke-linecap="round"/>
              </svg>
            </button>
          </div>

          <div id="rt-success" style="display:none;flex-direction:column;align-items:center;gap:14px;padding:40px 0;text-align:center;background:transparent">
            <div style="width:56px;height:56px;border-radius:50%;border:2px solid #E63946;display:flex;align-items:center;justify-content:center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12l5 5 9-9" stroke="#E63946" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <strong style="font-size:15px;font-weight:700;color:#111;background:transparent">Review submitted!</strong>
            <p style="font-size:13px;color:#aaa;margin:0;background:transparent">Thanks - it'll go live after a quick check, usually within 24 hrs.</p>
          </div>
        </div>
      </div>`;

    // Set product title in form header
    const em = document.getElementById('rt-form-title-em');
    if (em) em.textContent = '- ' + decodeURIComponent(title).substring(0, 50);

    // Build star picker
    buildStarPicker();

    // Wire events
    initFormToggle();
    initPhotoUpload();
    initCharCount();
    initSubmit();
  }

  /* ── Star picker ─────────────────────────────────────────────────────── */
  function buildStarPicker() {
    const pick = document.getElementById('rt-star-pick');
    if (!pick) return;
    for (let i = 1; i <= 5; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.val = i;
      btn.setAttribute('aria-label', i + ' star' + (i > 1 ? 's' : ''));
      btn.style.cssText = 'all:unset;cursor:pointer;padding:3px;color:#e0e0e0;display:inline-flex;transition:color .1s';
      btn.innerHTML = `<svg width="30" height="30" viewBox="0 0 16 16" fill="currentColor" style="display:block;transition:transform .15s" aria-hidden="true"><path d="M8 1l1.85 3.75L14 5.5l-3 2.92.71 4.12L8 10.5l-3.71 1.95.71-4.12L2 5.5l4.15-.75L8 1z"/></svg>`;
      const idx = i;
      btn.addEventListener('mouseenter', () => hoverStar(idx));
      btn.addEventListener('mouseleave', () => unhoverStar());
      btn.addEventListener('click', () => selectStar(idx));
      pick.appendChild(btn);
    }
  }

  function getStarBtns() { return document.querySelectorAll('#rt-star-pick button'); }

  function hoverStar(n) {
    getStarBtns().forEach((b, i) => b.style.color = i < n ? '#E63946' : '#e0e0e0');
    const hint = document.getElementById('rt-star-hint');
    if (hint) { hint.textContent = starLabels[n]; hint.style.opacity = '1'; }
  }

  function unhoverStar() {
    getStarBtns().forEach((b, i) => b.style.color = i < selectedRating ? '#E63946' : '#e0e0e0');
    const hint = document.getElementById('rt-star-hint');
    if (hint) {
      if (selectedRating) { hint.textContent = starLabels[selectedRating]; }
      else { hint.textContent = ''; hint.style.opacity = '0'; }
    }
  }

  function selectStar(n) {
    selectedRating = n;
    const input = document.getElementById('rt-rating');
    if (input) input.value = n;
    unhoverStar();
    const err = document.getElementById('rt-err-rating');
    if (err) err.textContent = '';
  }

  /* ── Form toggle ─────────────────────────────────────────────────────── */
  function initFormToggle() {
    document.querySelectorAll('[data-trigger]').forEach(btn => {
      btn.addEventListener('click', () => {
        const wrap = document.getElementById('rt-pr-form-wrap');
        if (!wrap) return;
        wrap.classList.contains('is-open') ? closeForm() : openForm(wrap);
      });
    });
    const closeBtn = document.getElementById('rt-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', closeForm);
  }

  function openForm(wrap) {
    wrap.style.maxHeight = '1000px';
    wrap.style.opacity = '1';
    wrap.classList.add('is-open');
    document.getElementById('rt-write-btn')?.classList.add('is-open');
    document.querySelectorAll('[data-trigger]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    // Scroll to form after transition starts - offset for sticky header
    setTimeout(() => {
      const stickyOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky_offset') || '0') || 80;
      const top = wrap.getBoundingClientRect().top + window.scrollY - stickyOffset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
      // Focus first star after scroll
      setTimeout(() => {
        const firstStar = wrap.querySelector('#rt-star-pick button');
        if (firstStar) firstStar.focus({ preventScroll: true });
      }, 400);
    }, 120);
  }

  function closeForm() {
    const wrap = document.getElementById('rt-pr-form-wrap');
    if (!wrap) return;
    wrap.style.maxHeight = '0';
    wrap.style.opacity = '0';
    wrap.classList.remove('is-open');
    document.getElementById('rt-write-btn')?.classList.remove('is-open');
    document.querySelectorAll('[data-trigger]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }

  /* ── Photo upload ────────────────────────────────────────────────────── */
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  const ALLOWED_EXTS  = ['.jpg', '.jpeg', '.png', '.webp'];
  const MAX_SIZE      = 5 * 1024 * 1024; // 5MB
  const MAX_FILES     = 3;
  let pendingPhotos   = []; // { file, dataUrl }

  // Magic bytes for real image verification
  const MAGIC = {
    'image/jpeg': [[0xFF,0xD8,0xFF]],
    'image/png':  [[0x89,0x50,0x4E,0x47]],
    'image/webp': [[0x52,0x49,0x46,0x46]], // RIFF header
  };

  function checkMagicBytes(file, mimeType) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = e => {
        const bytes = new Uint8Array(e.target.result);
        const sigs  = MAGIC[mimeType] || [];
        const ok = sigs.some(sig => sig.every((b, i) => bytes[i] === b));
        resolve(ok);
      };
      reader.readAsArrayBuffer(file.slice(0, 12));
    });
  }

  function photoErr(msg) {
    const el = document.getElementById('rt-photo-err');
    if (el) { el.textContent = msg; setTimeout(() => el.textContent = '', 4000); }
  }

  async function handlePhotoFiles(files) {
    const remaining = MAX_FILES - pendingPhotos.length;
    if (remaining <= 0) { photoErr('Maximum 3 photos allowed.'); return; }

    for (const file of Array.from(files).slice(0, remaining)) {
      // 1. MIME type check
      if (!ALLOWED_TYPES.includes(file.type)) {
        photoErr(`"${file.name}" is not allowed. Only JPG, PNG, WebP images.`); continue;
      }
      // 2. Extension check
      const ext = '.' + file.name.split('.').pop().toLowerCase();
      if (!ALLOWED_EXTS.includes(ext)) {
        photoErr(`"${file.name}" has an invalid extension.`); continue;
      }
      // 3. Size check
      if (file.size > MAX_SIZE) {
        photoErr(`"${file.name}" exceeds 5MB limit.`); continue;
      }
      // 4. Magic bytes - verify it's actually an image file
      const validBytes = await checkMagicBytes(file, file.type);
      if (!validBytes) {
        photoErr(`"${file.name}" doesn't appear to be a valid image file.`); continue;
      }
      // 5. Read as data URL for preview + submission
      await new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
          pendingPhotos.push({ file, dataUrl: e.target.result });
          renderPhotoPreviews();
          resolve();
        };
        reader.readAsDataURL(file);
      });
    }
  }

  function renderPhotoPreviews() {
    const preview = document.getElementById('rt-photo-preview');
    const drop    = document.getElementById('rt-photo-drop');
    if (!preview) return;
    preview.innerHTML = '';
    pendingPhotos.forEach((p, idx) => {
      const wrap = document.createElement('div');
      wrap.style.cssText = 'position:relative;width:72px;height:72px;flex-shrink:0';
      const img = document.createElement('img');
      img.src = p.dataUrl;
      img.style.cssText = 'width:72px;height:72px;object-fit:cover;border:1px solid #e5e5e5';
      img.alt = 'Review photo ' + (idx + 1);
      const del = document.createElement('button');
      del.type = 'button';
      del.style.cssText = 'all:unset;position:absolute;top:-6px;right:-6px;width:18px;height:18px;background:#E63946;color:#fff;border-radius:50%;font-size:11px;display:flex;align-items:center;justify-content:center;cursor:pointer;line-height:1;box-sizing:border-box';
      del.innerHTML = '×';
      del.onclick = () => { pendingPhotos.splice(idx, 1); renderPhotoPreviews(); };
      wrap.appendChild(img);
      wrap.appendChild(del);
      preview.appendChild(wrap);
    });
    // Hide drop zone if full
    if (drop) drop.style.display = pendingPhotos.length >= MAX_FILES ? 'none' : 'flex';
  }

  function initPhotoUpload() {
    const drop  = document.getElementById('rt-photo-drop');
    const input = document.getElementById('rt-photo-input');
    if (!drop || !input) return;

    drop.addEventListener('click', () => input.click());
    drop.addEventListener('dragover', e => { e.preventDefault(); drop.style.borderColor = '#E63946'; });
    drop.addEventListener('dragleave', () => { drop.style.borderColor = '#e0e0e0'; });
    drop.addEventListener('drop', e => {
      e.preventDefault();
      drop.style.borderColor = '#e0e0e0';
      handlePhotoFiles(e.dataTransfer.files);
    });
    input.addEventListener('change', () => { handlePhotoFiles(input.files); input.value = ''; });
  }

  /* ── Char count ──────────────────────────────────────────────────────── */
  function initCharCount() {
    const ta  = document.getElementById('rt-body');
    const cnt = document.getElementById('rt-body-count');
    if (ta && cnt) ta.addEventListener('input', () => { cnt.textContent = ta.value.length; });
  }

  /* ── Validation ──────────────────────────────────────────────────────── */
  function setErr(id, msg) { const el = document.getElementById(id); if (el) el.textContent = msg; }
  function clearErr(id) { const el = document.getElementById(id); if (el) el.textContent = ''; }

  function validate() {
    let ok = true;
    if (!selectedRating) { setErr('rt-err-rating', 'Please select a star rating.'); ok = false; } else clearErr('rt-err-rating');
    const name = document.getElementById('rt-name');
    if (!name?.value.trim()) { setErr('rt-err-name', 'Name is required.'); ok = false; } else clearErr('rt-err-name');
    const email = document.getElementById('rt-email');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email?.value.trim() || '')) { setErr('rt-err-email', 'Enter a valid email.'); ok = false; } else clearErr('rt-err-email');
    const body = document.getElementById('rt-body');
    if ((body?.value.trim().length || 0) < 15) { setErr('rt-err-body', 'Review must be at least 15 characters.'); ok = false; } else clearErr('rt-err-body');
    return ok;
  }

  /* ── Submit ──────────────────────────────────────────────────────────── */
  function initSubmit() {
    const btn = document.getElementById('rt-submit');
    if (btn) btn.addEventListener('click', handleSubmit);
  }

  async function handleSubmit() {
    if (!validate()) return;

    const webhookUrl = document.getElementById('rt-webhook')?.value;
    if (!webhookUrl) { setErr('rt-err-body', 'Submission endpoint not configured.'); return; }

    const payload = {
      product_id:     document.getElementById('rt-product-id')?.value,
      product_handle: document.getElementById('rt-product-handle')?.value,
      product_title:  document.getElementById('rt-product-title')?.value,
      rating:         String(selectedRating),
      name:           document.getElementById('rt-name')?.value.trim(),
      email:          document.getElementById('rt-email')?.value.trim().toLowerCase(),
      bike_model:     (document.getElementById('rt-bike')?.value || '').trim(),
      city:           (document.getElementById('rt-city')?.value || '').trim(),
      body:           document.getElementById('rt-body')?.value.trim(),
      submitted_at:   new Date().toISOString(),
      source:         'product_page',
      photos:         pendingPhotos.map(p => p.dataUrl), // base64 - n8n uploads to Shopify Files
    };

    const btn     = document.getElementById('rt-submit');
    const spinner = document.getElementById('rt-spinner');
    if (btn) btn.disabled = true;
    if (spinner) spinner.style.display = 'block';

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        // Show success
        const form = document.getElementById('rt-pr-form-wrap').querySelector('div');
        if (form) {
          form.querySelectorAll('.rt-form-field, div[style*="grid"], div[style*="flex"][style*="margin-bottom"]').forEach(el => el.style.display = 'none');
        }
        const success = document.getElementById('rt-success');
        if (success) success.style.display = 'flex';
        setTimeout(() => {
          closeForm();
          setTimeout(() => {
            if (success) success.style.display = 'none';
            if (btn) { btn.disabled = false; }
            if (spinner) spinner.style.display = 'none';
            selectedRating = 0;
            unhoverStar();
            ['rt-name','rt-email','rt-bike','rt-city','rt-body'].forEach(id => {
              const el = document.getElementById(id);
              if (el) el.value = '';
            });
            const cnt = document.getElementById('rt-body-count');
            if (cnt) cnt.textContent = '0';
            pendingPhotos = [];
            renderPhotoPreviews();
          }, 500);
        }, 3500);
      } else {
        throw new Error('HTTP ' + res.status);
      }
    } catch (err) {
      console.error('[RT Reviews]', err);
      if (btn) btn.disabled = false;
      if (spinner) spinner.style.display = 'none';
      setErr('rt-err-body', 'Something went wrong. Please try again.');
    }
  }

  /* ── Scroll animations ───────────────────────────────────────────────── */
  function initScrollAnimations() {
    const score = document.querySelector('.rt-pr__score');
    const bars  = document.querySelectorAll('.rt-pr__bar-row');
    const cards = document.querySelectorAll('.rt-pr__review');

    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('rt-in');
        if (e.target.classList.contains('rt-pr__bar-row')) {
          const fill = e.target.querySelector('.rt-pr__bar-fill');
          if (fill) setTimeout(() => { fill.style.width = fill.dataset.w + '%'; }, 60);
        }
        io.unobserve(e.target);
      });
    }, { threshold: 0.2 });

    if (score) io.observe(score);
    bars.forEach((b, i) => { b.style.transitionDelay = (i * 0.04) + 's'; io.observe(b); });
    /* RT: no per-card index delay. Absolute-index stagger made every card past
       the 3rd (incl. the "Show more" batch) lag by a growing amount each time
       it scrolled into view. Each card now reveals immediately on entry. */
    cards.forEach((c) => { c.style.transitionDelay = '0s'; io.observe(c); });
  }

  /* ── Boot ────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();